// extracted by mini-css-extract-plugin
export default {"box":"ContentBox_box__osXxm"};